import leadSourceFields from './lead-sources';

export default {
    customFields: [
        {resource: 'customers', path: 'customFields'},
    ],
    fields: [
        {field: 'id', isDefault: true},
        {field: 'email', isDefault: true},
        {field: 'firstName', isDefault: true},
        {field: 'lastName', isDefault: true},
        {field: 'createdTime', isDefault: true},
        {field: 'updatedTime', isDefault: true},
        {field: 'primaryAddress/firstName', isDefault: false},
        {field: 'primaryAddress/lastName', isDefault: false},
        {field: 'primaryAddress/address', isDefault: false},
        {field: 'primaryAddress/address2', isDefault: false},
        {field: 'primaryAddress/organization', isDefault: false},
        {field: 'primaryAddress/city', isDefault: false},
        {field: 'primaryAddress/region', isDefault: false},
        {field: 'primaryAddress/country', isDefault: false},
        {field: 'primaryAddress/postalCode', isDefault: false},
        {field: 'primaryAddress/email', isDefault: false},
        {field: 'primaryAddress/phoneNumber', isDefault: false},
        {field: 'defaultPaymentInstrument/last4', isDefault: true},
        {field: 'defaultPaymentInstrument/binId', isDefault: true},
        {field: 'defaultPaymentInstrument/status', isDefault: true},
        {field: 'defaultPaymentMethodName', isDefault: true},
    ].concat(leadSourceFields),
};
